import { render, staticRenderFns } from "./FormPresenca.vue?vue&type=template&id=c543c2d0"
import script from "./FormPresenca.vue?vue&type=script&lang=js"
export * from "./FormPresenca.vue?vue&type=script&lang=js"
import style0 from "./FormPresenca.vue?vue&type=style&index=0&id=c543c2d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports